var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"has-skeleton tabs-skeleton mb-2"}),_c('div',{staticClass:"has-skeleton buttons-skeleton mb-3"}),_c('div',{staticClass:"card has-skeleton table-skeleton"})])
}]

export { render, staticRenderFns }